import angular from 'angular';

import { PLANS } from 'config';

import template from './tsz-company-subscriptions.html';
import './tsz-company-subscriptions.styl';

import editSubscriptionTpl from './modals/edit-subscription.html';

function controller($tszToast, $mdDialog, AdminService) {

  'ngInject';

  this.subscriptions = [];

  this.loadCompanySubscriptions = () => {
    AdminService.getSubscriptions(this.companyId)
    .then((response) => {
      this.subscriptions = response;
    }).catch(() => {
      $tszToast.showError('Se ha producido un error al cargar las suscripciones de la compañía');
    });
  };

  this.create = () => {
    this.edit({
      startDate: new Date(),
      endDate: new Date(),
      paymentDueDate: new Date(),
    });
  };

  this.edit = (subscription) => {

    $mdDialog.show({
      controller: ($scope) => {

        $scope.subscription = {
          id: subscription.id,
          plan: subscription.plan,
          startDate: new Date(subscription.startDate),
          endDate: new Date(subscription.endDate),
          paymentDueDate: new Date(subscription.paymentDueDate),
          paymentDue: subscription.paymentDue,
        };

        $scope.plans = PLANS;

        $scope.save = () => {

          const s = {
            plan: $scope.subscription.plan,
            startDate: new Date($scope.subscription.startDate).getTime(),
            endDate: new Date($scope.subscription.endDate).getTime(),
            paymentDueDate: new Date($scope.subscription.paymentDueDate).getTime(),
            paymentDue: $scope.subscription.paymentDue,
          };

          if ($scope.subscription.id) {
            AdminService.updateSubscription(this.companyId, $scope.subscription.id, s)
            .then(() => {
              $mdDialog.hide();
              $tszToast.showSuccess('Guardado');
              this.loadCompanySubscriptions();
            }).catch(() => {
              $tszToast.showError('Se ha producido un error al actualizar la suscripción');
            });
          } else {
            AdminService.createSubscription(this.companyId, s)
            .then(() => {
              $tszToast.showSuccess('La suscripción se ha creado correctamente');
              this.loadCompanySubscriptions();
              $mdDialog.hide();
            }).catch(() => {
              $tszToast.showError('Se ha producido un error al crear la suscripción');
            });
          }
        };

        $scope.close = () => {
          $mdDialog.hide();
        };
      },
      template: editSubscriptionTpl,
      parent: angular.element(document.body),
      clickOutsideToClose:true,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

  this.showDeleteConfirm = (subscription, ev) => {
    // Appending dialog to document.body to cover sidenav in docs app
    const confirm = $mdDialog.confirm()
          .title('¿Eliminar suscripción?')
          .textContent('Esta operación eliminará de forma irreversible la suscripción seleccionada.')
          .ariaLabel('Eliminar suscripción')
          .targetEvent(ev)
          .ok('Aceptar')
          .cancel('Cancelar');

    $mdDialog.show(confirm).then(() => {
      this.delete(subscription);
    });
  };

  this.delete = (subscription) => {
    AdminService.deleteSubscription(this.companyId, subscription.id)
    .then(() => {
      $tszToast.showSuccess('Suscripción eliminada correctamente');
      this.loadCompanySubscriptions();
    }).catch(() => {
      $tszToast.showError('Se ha producido un error al eliminar la suscripción');
    });
  };

  //
  // INIT
  //

  this.loadCompanySubscriptions();

}

export default {
  template,
  bindings: {
    companyId: '<',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-company-subscriptions/tsz-company-subscriptions.js